module.exports = __webpack_public_path__ + "img/ico_other.4b30d0ab.svg";